import React from "react";
import { Link } from "react-router-dom";
import "./administration.css"; // Import a CSS file for styling
import SchoolIcon from "@mui/icons-material/School";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AcademicsImage from "./publicImages/m.png";

import Logo from "../homepage/home_pictures/logos/Manga_Cons _Logo3.png";

import Footer from "../homepage/Footer";

export default function Administration() {
  const adminPositions = [
    "Provost",
    "Deputy Provost Admin",
    "Deputy Provost Academic",
    "Registrar",
    "STDO",
    "College Bursar",
    "Chief Internal Auditor",
    "College Librarian",
    "Admission Officer",
    "Examination Officer",
    "Students Affair Officer",
    "Academic Officer/Secretary",
  ];

  return (
    <div className="admin-list-container fx-cl">
      <header className="admin-list-header fx-cl">
        <h2>Meet Our Administrative Team</h2>
        <p>
          Introducing the leaders of Manga College of Nursing Sciences <br />
          who drive our institution's excellence.
        </p>
      </header>
      <nav
        className="mcons-home-navbar-b "
        style={{ backgroundColor: "#065AD8", padding: "4rem" }}
      >
        <div className="mcons-home-logo">
          <Link to="/" className="loginLogo">
            <img src={Logo} alt="mcons-logo" />
          </Link>
        </div>
        <div className="mcons-home-nav-toggle">&#9776;</div>
        <ul className={`mcons-home-nav-menu-b fx-ac `}>
          <div className="home-nav dropdown">
            <li>
              <Link to="/administration" className="fx-ac ">
                <span>Administration</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>

            <div className="home-nav dropdown-content ">
              <div className="administrationDropdown">
                <Link href="#home">Provost</Link>
                <Link href="#home">Deputy Provost Admin</Link>
                <Link href="#home">Deputy Provost Academic</Link>
                <Link href="#home">Registrar</Link>
                <Link href="#home">STDO</Link>
                <Link href="#home">College Bursar</Link>
                <Link href="#home">Chief Internal Auditor</Link>
                <Link href="#home">College Librarian</Link>
                <Link href="#home">Admission Officer</Link>
                <Link href="#home">Examination Officer</Link>
                <Link href="#home">Students Affair Officer</Link>
                <Link href="#home">Academic Secretary</Link>
              </div>
            </div>
          </div>
          <div className="home-nav dropdown">
            <li>
              <Link to="/academics" className="fx-ac ">
                <span>Academics</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>
            <div className="home-nav dropdown-content">
              <Link href="#home">Basic Midwifery </Link>
              <Link href="#services">Basic Nursing</Link>
              <Link href="#about">Division of General Studies</Link>
            </div>
          </div>
          <div className="home-nav dropdown">
            <li>
              <Link to="/admission" className="fx-ac ">
                <span>Admission</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>
            <div className="home-nav dropdown-content">
              <Link href="#home">Check Admission Status</Link>
              <Link href="#home">Application Requirement</Link>
            </div>
          </div>
          <li>
            <Link to="/library">Library</Link>
          </li>

          <div className="home-nav dropdown">
            <li>
              <Link to="/registrations" className="fx-ac ">
                <span>Registration</span>
                <KeyboardArrowRightIcon fontSize="large" />
              </Link>
            </li>

            <div className="home-nav dropdown-content">
              <Link to="/registrations">Apply now</Link>
              <Link href="#home">How to apply</Link>
            </div>
          </div>

          <li>
            <Link to="/about-us">About </Link>
          </li>
          <li>
            <Link to="/contact-us">Contant us</Link>
          </li>
        </ul>
        <div className="fx-ac space2">
          <span>
            <Link style={{ color: "#fff" }} to="/staff_login">
              Staffs
            </Link>
          </span>
          <Link
            className="home-nav-btn"
            to="/student_login"
            style={{ backgroundColor: "#fff", color: "#065AD8" }}
          >
            Student portal
          </Link>{" "}
        </div>
      </nav>

      <section className="admin-list-section">
        {adminPositions.map((e, i) => (
          <figure className="administrationCard fx-cl fx-jb fx-ac" key={i}>
            <div>
              <figure className="academicsImg">
                <img src={AcademicsImage} alt="" />
              </figure>
            </div>
            <div>
              <h4>{e}</h4>
              <p>Dr, Somebody Surnames</p>
            </div>
          </figure>
        ))}
      </section>
      <Footer />
    </div>
  );
}
